import {useParams} from "react-router-dom";
import {useAuth} from "hooks/useAuth";
import {useSetting} from "../contexts/setting";

export function shouldUseBgDerivation({
  featureEnabled,
  sceneId,
}: {
  featureEnabled: boolean;
  sceneId: string | undefined;
}): boolean {
  return featureEnabled && !sceneId;
}

/**
 * The `bgDerivation` feature flag as every consumer must read it. Saved scenes
 * and routes without catalog data stay on the legacy transform path.
 *
 * Saved scenes stay on the legacy path by design — their stored payload already
 * holds the resolved crop/background, so re-deriving it from the catalog would
 * change what a saved scene renders. The condition lives here so components
 * below App don't each re-derive it: one copy drifting is a silent split-brain
 * (half the page derived, half legacy). App calls the pure selector directly
 * because it receives `featureFlags` as a prop from AppRoot.
 */
export function useBgDerivation(): boolean {
  const {sceneId} = useParams();
  const {featureFlags} = useAuth();
  const {isControlledBanner} = useSetting();
  if (isControlledBanner) return false;
  return shouldUseBgDerivation({
    featureEnabled: featureFlags?.bgDerivation === true,
    sceneId,
  });
}
